module.exports = __webpack_public_path__ + "img/title_wechat.e44268ea.svg";